import { useFeatureGate } from '@atlassian/feature-gates-react';
import { OAuthConsentFeatureGate } from '../../FeatureGates/FeatureGates';

/**
 * Single source of truth for the "Authorize app — Ready for dev" Rovo visual
 * refresh rollout gate (`oauth-consent_rovo-visual-refresh`).
 *
 * Each redesigned Rovo consent component (site selector, permissions card,
 * sticky footer, logo header) calls this hook and renders the new UI only when
 * it returns `true`; otherwise it falls back to the legacy UI.
 *
 * Defaults to `false` until feature-gate initialization completes (fail-safe).
 */
export function useRovoVisualRefresh(): boolean {
  return useFeatureGate(OAuthConsentFeatureGate.ROVO_VISUAL_REFRESH);
}

export default useRovoVisualRefresh;
